var _a;
export const interpolate = (str, values) => {
    let result = str;
    for (const key of Object.keys(values)) {
        result = result.replace(`%{${key}}`, values[key]);
    }
    return result;
};
String.prototype.i__ =
    (_a = String.prototype.i__) !== null && _a !== void 0 ? _a : function (values) {
        return interpolate(this, values);
    };
//# sourceMappingURL=interpolation.js.map